import {
  ClientMessage,
  SWMessage,
  SWMessagePayload,
} from "@/modules/message/types/message";

export const listenToSWMessages = (
  callback: (message: ClientMessage) => void
) => {
  if (!navigator?.serviceWorker) {
    console.error("Service Worker not ready yet");
    return;
  }
  navigator.serviceWorker.addEventListener(
    "message",
    (event: MessageEvent<ClientMessage>) => {
      console.debug("Received message from service worker:", event.data);
      if (event.data && event.data.type === "CLIENT_MESSAGE") {
        callback(event.data);
      } else {
        console.error("Unknown message type:", event.data?.type);
      }
    }
  );
};

export const postMessageToSW = (message: SWMessagePayload) => {
  const msg: SWMessage = {
    type: "SW_MESSAGE",
    payload: message,
  };
  navigator.serviceWorker?.controller?.postMessage(msg);
};
